// Error.js
import React from 'react';
import { Alert } from 'react-bootstrap';

const Error = ({ message, height}) => (
  <Alert variant="danger" style={{height:height}}>
    Error: {message}
  </Alert>
);

export default Error;